//Create simple react Component

import React, { useState, useCallback, useEffect } from "react";
import { Button, Modal } from "stories/components";
import { useStoreState, useStoreActions } from 'easy-peasy';


import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import PurchaseEdit from "views/app/PurchaseEdit/PurchaseEdit"
import SaleEdit from "views/app/SaleEdit/SaleEdit"
import PrivateInvestmentFundEdit from "views/app/PrivateInvestmentFundEdit/PrivateInvestmentFundEdit"
import { useTargetPortfolio } from "components/TargetPortfolioDialog/useTargetPortfolio"




const NewEvent = (props) => {
    const { t } = useTranslation();
    const count = useStoreState((state) => state.purchases?.count);
    const getUnmadeDividendTransactions = useStoreActions((actions) => actions.unmadeDividendTransactions.getUnmadeDividendTransactions);
    const getUnmadeSplitTransactions = useStoreActions((actions) => actions.unmadeSplitTransactions.getUnmadeSplitTransactions);

    // const handleCancel = () => {
    //     props.handleReject()
    // }
    const [filters, setFilters] = useState({})
    // With several active portfolios purchase and sale ask for the portfolio first (#1409).
    // "arvopaperi" does not depend on the portfolio and opens directly.
    const { choose } = useTargetPortfolio()

    // Modal: New/Edit Purchase
    const [modalEditPurchaseOpen, setModalEditPurchaseOpen] = useState(false)
    const [modalEditPurchaseId, setModalEditPurchaseId] = useState()
    const history = useHistory();

    const toggleModalEditPurchase = () => {
        setModalEditPurchaseOpen(s => !s);
    }
    
    const openModalEditPurchase = (id, related_model_type, ticker_symbol) => {
        setModalEditPurchaseOpen(true)
        setModalEditPurchaseId(id);
        // setInvestmentType(related_model_type)
        // setTickerSymbol(ticker_symbol)
    }
    
    const modalEditPurchaseResolve = () => {
        console.log("modalEditPurchaseResolve")
        setModalEditPurchaseOpen(false);
        setModalEditPurchaseId(null);
        getUnmadeDividendTransactions()
        getUnmadeSplitTransactions()
        history.push('/dashboard/transactions')
    }
    
    const modalEditPurchaseReject = () => {
        setModalEditPurchaseOpen(false);
        setModalEditPurchaseId(null);
    }

    // Modal: New Sale
    const [modalEditSaleOpen, setModalEditSaleOpen] = useState(false)
    const [modalEditSaleId, setModalEditSaleId] = useState()

    const toggleModalEditSale = () => {
        setModalEditSaleOpen(s => !s);
    }
    
    const openModalEditSale = (id, related_model_type, ticker_symbol) => {
        setModalEditSaleOpen(true)
        setModalEditSaleId(id);
        // setInvestmentType(related_model_type)
        // setTickerSymbol(ticker_symbol)
    }
    
    const modalEditSaleResolve = () => {
        console.log("modalEditSaleResolve")
        setModalEditSaleOpen(false);
        setModalEditSaleId(null);
        getUnmadeDividendTransactions()
        getUnmadeSplitTransactions()
        history.push('/dashboard/transactions')
    }
    
    const modalEditSaleReject = () => {
        setModalEditSaleOpen(false);
        setModalEditSaleId(null);
    }
    
    // Modal: New/Edit
    
    const [modalEditOpen, setModalEditOpen] = useState(false)
    const [modalEditId, setModalEditId] = useState()
    
    const toggleModalEdit = () => {
        setModalEditOpen(s => !s);
    }
    
    const openModalEdit = (id) => {
        setModalEditOpen(true)
        setModalEditId(id);
    }
    
    const modalEditResolve = () => {
        setModalEditOpen(false);
        setModalEditId(null);
        history.push('/dashboard/private_investment_funds')

        // getPrivateInvestmentFunds(filters)
    }
    
    const modalEditReject = () => {
        setModalEditOpen(false);
        setModalEditId(null);
    }


    return (
        <>
            <div className="sk-quick-actions">
                <div className="sk-quick-actions__title">{t("quick_action_header", "Pikatoiminnot")}</div>
                <div className="sk-quick-actions__buttons">
                    <Button
                        size="sm"
                        variant="secondary"
                        className="sk-quick-actions__btn"
                        onClick={async () => { if (await choose("purchase")) openModalEditPurchase(null, "XHEL", null) }}
                    >
                        <i className="fas fa-shopping-cart sk-quick-actions__icon" aria-hidden />
                        <span>{t("quick_action_new_purchase", "osto")}</span>
                    </Button>
                    <Button
                        size="sm"
                        variant="secondary"
                        className="sk-quick-actions__btn"
                        onClick={async () => { if (await choose("sale")) openModalEditSale(null, "XHEL", null) }}
                    >
                        <i className="fas fa-tag sk-quick-actions__icon" aria-hidden />
                        <span>{t("quick_action_new_sale", "myynti")}</span>
                    </Button>
                    <Button
                        size="sm"
                        variant="secondary"
                        className="sk-quick-actions__btn"
                        onClick={() => openModalEdit(null, "XHEL", null)}
                    >
                        <i className="fas fa-plus sk-quick-actions__icon" aria-hidden />
                        <span>{t("quick_action_new_security", "arvopaperi")}</span>
                    </Button>
                </div>
            </div>

            <Modal
                // title={modalEditPurchaseId > 0 ? t("Muokkaa ostokirjausta") : t("Uusi ostokirjaus")}
                isOpen={modalEditPurchaseOpen}
                toggleModal={toggleModalEditPurchase}
                size="modal-xl"
                showHeader={false}
                classNameBody="p-0 padding-0"
            >
                <PurchaseEdit
                objectId={modalEditPurchaseId}
                handleResolve={modalEditPurchaseResolve}
                handleReject={modalEditPurchaseReject}
                defaultStockMarket={"XHEL"}
                defaultInvestmentType={10}
                setFilters={setFilters}
                transaction_count = {count}

                // transaction_count = {count}
                // portfoliosSummary={portfoliosSummary}
                />
            </Modal>

            <Modal
                // title={modalEditPurchaseId > 0 ? t("Muokkaa ostokirjausta") : t("Uusi ostokirjaus")}
                isOpen={modalEditSaleOpen}
                toggleModal={toggleModalEditSale}
                size="modal-xl"
                showHeader={false}
                classNameBody="p-0 padding-0"
            >
                <SaleEdit
                objectId={modalEditSaleId}
                handleResolve={modalEditSaleResolve}
                handleReject={modalEditSaleReject}
                defaultStockMarket={"XHEL"}
                defaultInvestmentType={10}
                setFilters={setFilters}
                transaction_count = {count}

                // transaction_count = {count}
                // portfoliosSummary={portfoliosSummary}
                />
            </Modal>

            <Modal
                title={t("PrivateInvestmentFundEdit_title", "Oma arvopaperi")}
                isOpen={modalEditOpen}
                toggleModal={toggleModalEdit}
                showHeader={false}
                size="modal-xl"
                classNameBody="p-0 padding-0"
                >
                <PrivateInvestmentFundEdit
                objectId={modalEditId}
                handleResolve={modalEditResolve}
                handleReject={modalEditReject}
                />
            </Modal>
        </>
    )
}

export default NewEvent;
